module.exports = __webpack_public_path__ + "static/media/reddit_sm.08a22dafea304f46055ba6645fc1410c.svg";